import React from 'react'
import { InputText } from 'primereact/inputtext'
import './lts-input-text.scss'

export default function LtsInputText(props) {
  const {
    onChange: onChangeProp,
    label,
    hidden,
    value = '',
    name,
    maxLength,
    autoFocus,
    keyfilter,
    style,
    disabled,
    className,
    button,
    ...rest
  } = props

  const handleChange = (event) => {
    onChangeProp?.(event.target.value)
  }

  const inputElement = (
    <InputText
      {...rest}
      value={value}
      onChange={handleChange}
      name={name}
      maxLength={maxLength}
      autoFocus={autoFocus}
      keyfilter={keyfilter}
      style={style}
      disabled={disabled}
      className={className}
    />
  )

  if (button) {
    return (
      <div className="lts-input-text">
        <div className="p-inputgroup">
          <span className="p-float-label">
            {inputElement}
            {button}
            {label && !hidden && <label>{label}</label>}
          </span>
        </div>
      </div>
    )
  }

  return (
    <span className="p-float-label">
      {inputElement}
      {label && !hidden && <label>{label}</label>}
    </span>
  )
}
